import Header from "./components/header"
import LogEntry from "./components/log"
import TheData from "./data"


export default function App() {

    const logs = TheData.map(log => {
        return (
            <LogEntry
                key={log.id}
                log={log}
            >
            </LogEntry>
        )
    })
    return (
        <div className="app-container">
            <Header></Header>

            <div className="sub-app-container">
                <div className="container">
                    {logs}
                </div>
                <div className="container2">
                    {logs}
                </div>
                <div className="container3">
                    {logs}
                </div>
            </div>
        </div>
    )


}